let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gUVVx")).then(() => parcelRequire('3MZo0'));